import React, {useEffect, useRef, useState} from "react";
import {Form} from "@unform/web";
import * as Yup from "yup";
import {toast} from "react-toastify";
import messageTypes from "../../../constants/MessagesTypes";
import {AiOutlineSearch} from "react-icons/ai";
import {IoIosArrowBack, IoIosArrowForward} from "react-icons/io";
import CustomButton from "../../../components/Form/Button";
import {dateCurrent, dateFirstDayCurrent, firstDayMonth} from "../../../utils/date";
import InputDate from "../../../components/Form/InputDate";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableFooter from "@mui/material/TableFooter";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {useSelector} from "react-redux";
import {getHistoricoPlacar} from "../../../services/Trading";
import {useTranslation} from "react-i18next";
import {currencyFormat} from "../../../utils/masks";
import DivDiagonal from "../../../components/DivDiagonal";
import {TradingWrapper, ContentArea} from "../../Trading/styles";
import {
    StrategyProductCard,
    StrategyEmptyState,
    StrategyPaginationInfo,
    StrategyPaginationButton,
    StrategyLoadingButton,
} from "../../Strategy/styles";
import {FormWrapper} from "../../../styles/listPageTheme";
import {
    PlacarStack,
    PlacarPageHeader,
    PlacarWideCardColumn,
    PageInner,
    FilterSection,
    FilterTitle,
    FilterRow,
    FilterField,
    FilterActions,
    calcPrimaryButtonStyle,
    TableSection,
    PlacarTableWrap,
    PlacarTableContainer,
} from "./styles";

export default function Placar() {
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [page, setPage] = useState(1);
    const {isActiveSignature} = useSelector(
        (state) => state.UserReducer
    );

    const {coinType} = useSelector(
        (state) => state.BankReducer
    );

    const formRef = useRef(null);

    const [filter, setFilter] = useState([
        {
            startDate: dateFirstDayCurrent(),
            endDate: dateCurrent(),
        }
    ]);

    const { t } = useTranslation();

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        getHistoricoPlacar({
            page: page,
            per_page: 25,
            startDate: filter[0].startDate,
            endDate: filter[0].endDate,
        }).then((data) => {
            if (cancelled) {
                return;
            }
            setLoading(false);
            if (!data || data === '' || !data.data) {
                setList({ data: [], total_page: 0, next_page: false });
                return;
            }

            setList(data.data);
        });

        return function cleanup() {
            cancelled = true;
        };
    }, [page, filter]);

    async function handleSubmit(data) {
        try {

            formRef.current.setErrors({});
            const schema = Yup.object().shape({});

            await schema.validate(data, {
                abortEarly: false,
            });

            setFilter(
                [{
                    startDate: data.startDate,
                    endDate: data.endDate,
                }]
            );
            setPage(1);

        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                const validationErrors = {};
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
                toast.warning(messageTypes.REQUIRED_FIELDS);
                return;
            }

            toast.error(messageTypes.ERROR);
        }
    }

    const buttonHoverIn = (e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.45)';
    };
    const buttonHoverOut = (e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = calcPrimaryButtonStyle.boxShadow;
    };

    const renderMoneyCell = (profitObtained) => {
        const v = parseFloat(profitObtained);
        const text = `${coinType} ${currencyFormat(v)}`;
        if (v > 0) {
            return <span style={{color: '#5bd37c', fontWeight: 700}}>{text}</span>;
        }
        if (v < 0) {
            return <span style={{color: '#ff8a8a', fontWeight: 700}}>{text}</span>;
        }
        return <span style={{fontWeight: 700}}>{text}</span>;
    };

    return (
        <>
            {isActiveSignature && (
                <TradingWrapper>
                    <DivDiagonal/>
                    <ContentArea>
                        <PageInner>
                            <PlacarStack>
                                <PlacarPageHeader>
                                    <h1>
                                        <i className="fa fa-list-ul" aria-hidden="true"/>
                                        {' '}{t('history_score_card_title')}
                                    </h1>
                                </PlacarPageHeader>

                                <PlacarWideCardColumn>
                                    <StrategyProductCard>
                                        <FilterSection>
                                            <Form ref={formRef} onSubmit={handleSubmit}>
                                                <FilterTitle>
                                                    <i className="fas fa-funnel-dollar" aria-hidden="true"/>
                                                    {t('filter')}
                                                </FilterTitle>
                                                <FormWrapper>
                                                    <FilterRow>
                                                        <FilterField>
                                                            <InputDate
                                                                name="startDate"
                                                                label={t('filter_start_date')}
                                                                value={firstDayMonth()}
                                                                size={"small"}
                                                            />
                                                        </FilterField>
                                                        <FilterField>
                                                            <InputDate
                                                                name="endDate"
                                                                label={t('filter_end_date')}
                                                                value={new Date()}
                                                                size={"small"}
                                                            />
                                                        </FilterField>
                                                        <FilterActions>
                                                            <CustomButton
                                                                type="submit"
                                                                style={calcPrimaryButtonStyle}
                                                                onMouseEnter={buttonHoverIn}
                                                                onMouseLeave={buttonHoverOut}
                                                                startIcon={<AiOutlineSearch/>}
                                                            >
                                                                {t('filter_btn_submmit')}
                                                            </CustomButton>
                                                        </FilterActions>
                                                    </FilterRow>
                                                </FormWrapper>
                                            </Form>
                                        </FilterSection>

                                        <TableSection>
                                            <PlacarTableWrap>
                                                {loading ? (
                                                    <StrategyLoadingButton
                                                        className="btn btn-primary text-capitalize font-weight-bold"
                                                        loading={loading}
                                                        type="button"
                                                    >
                                                        {t('loading')}
                                                    </StrategyLoadingButton>
                                                ) : (
                                                    <>
                                                        {list && list.data && list.data.length ? (
                                                            <PlacarTableContainer>
                                                                <Table aria-label={t('history_score_card_title')}>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell align="center">
                                                                                {t('history_score_table_col_date')}
                                                                            </TableCell>
                                                                            <TableCell align="center">
                                                                                {t('history_score_table_col_score')}
                                                                            </TableCell>
                                                                            <TableCell align="center">
                                                                                {t('profit_prejudice')}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {list.data.map((row) => (
                                                                            <TableRow key={row.id}>
                                                                                <TableCell align="center" component="th" scope="row">
                                                                                    {new Date(row.created.date).toLocaleDateString()}
                                                                                </TableCell>
                                                                                <TableCell align="center">
                                                                                    {row.qtdeWin} X {row.qtdeLoss}
                                                                                </TableCell>
                                                                                <TableCell align="center">
                                                                                    {renderMoneyCell(row.profitObtained)}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableBody>
                                                                    <TableFooter>
                                                                        <TableRow>
                                                                            <TableCell colSpan={3}>
                                                                                <div style={{
                                                                                    display: 'flex',
                                                                                    justifyContent: 'space-between',
                                                                                    alignItems: 'center',
                                                                                    flexWrap: 'wrap',
                                                                                    gap: 12,
                                                                                }}>
                                                                                    <StrategyPaginationInfo>
                                                                                        {t('table_pagination_text', {
                                                                                            page: page,
                                                                                            totalPage: (list.total_page != null ? list.total_page : 0) + 1,
                                                                                        })}
                                                                                    </StrategyPaginationInfo>
                                                                                    <div style={{display: 'flex', gap: 8, flexWrap: 'wrap'}}>
                                                                                        <StrategyPaginationButton
                                                                                            type="button"
                                                                                            onClick={() => setPage((p) => p - 1)}
                                                                                            disabled={page <= 1}
                                                                                        >
                                                                                            <IoIosArrowBack/> {t('table_pagination_back')}
                                                                                        </StrategyPaginationButton>
                                                                                        <StrategyPaginationButton
                                                                                            type="button"
                                                                                            onClick={() => setPage((p) => p + 1)}
                                                                                            disabled={!list.next_page}
                                                                                        >
                                                                                            {t('table_pagination_next')} <IoIosArrowForward/>
                                                                                        </StrategyPaginationButton>
                                                                                    </div>
                                                                                </div>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </TableFooter>
                                                                </Table>
                                                            </PlacarTableContainer>
                                                        ) : (
                                                            <StrategyEmptyState>
                                                                <i className="fa fa-list-ul" aria-hidden="true"/>
                                                                <p>{t('history_score_empty_title')}</p>
                                                                <span>{t('history_score_empty_subtitle')}</span>
                                                            </StrategyEmptyState>
                                                        )}
                                                    </>
                                                )}
                                            </PlacarTableWrap>
                                        </TableSection>
                                    </StrategyProductCard>
                                </PlacarWideCardColumn>
                            </PlacarStack>
                        </PageInner>
                    </ContentArea>
                </TradingWrapper>
            )}
        </>
    );
}
